import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { font } from "../styles/font";
import { theme } from "../styles/theme";

export const NoDataFound = ({ message }) => {
  return (
    <>
      <Box
        padding="15px"
        borderRadius="10px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        backgroundColor={theme.col_3_alpha}
      >
        <Typography
          fontFamily={font.family.fm_2}
          fontSize={font.size.fs_5}
          color={theme.col_3}
          fontWeight="bold"
        >
          {message}
        </Typography>
      </Box>
    </>
  );
};
